import React from "react";
import "./index.css";
import ProgressDonut from "./ProgressDonut";

const DreamProject = () => {
  const phases = [
    {
      name: "Land Acquisition",
      phase: "Phase 1",
      collected: 1365920,
      target: 4000000,
      disabled: false,
    },
    {
      name: "Building Construction",
      phase: "Phase 2",
      collected: 0,
      target: 3000000,
      disabled: true,
    },
    {
      name: "Infrastructure Setup",
      phase: "Phase 3",
      collected: 0,
      target: 2000000,
      disabled: true,
    },    
    {
      name: "Building Extension",
      phase: "Phase 4",
      collected: 0,
      target: 3000000,
      disabled: true,
    },
  ];

  const handleDonate = () => {
    window.open("https://pages.razorpay.com/pl_RZ9hN5dDPQVrlK/view", "_blank");
  };

  // Check if phase is 100% completed
  const isPhaseComplete = (collected, target) => {
    return collected >= target;
  };

  return (
   <div className="dream-project-section">
      {/* hero / page header */}
      <div
        className="page-hero"
        role="img"
        aria-label="Dream Project banner"
        style={{ backgroundImage: "url('/Images/dreamProjectBanner.png')" }}
      >
      </div>

      {/* Remove duplicate heading below if present */}
      {/* ...rest of existing code... */}
      <br />
      <h1 className="dream-project-heading">Status</h1>
      <div className="dream-charts-container">
        {phases.map((phase, idx) => {
          const isComplete = isPhaseComplete(phase.collected, phase.target);
          
          return (
            <div key={idx} className="dream-chart-card">
              <h3 className="dream-chart-title">{phase.name}</h3>
              <p className="dream-chart-phase">{phase.phase}</p>
              <ProgressDonut
                collected={phase.collected}
                target={phase.target}
                size={180}
                stroke={18}
                currency="₹"
                isComplete={isComplete}
              />
              <button 
                className="dream-card-donate-btn" 
                onClick={handleDonate}
                disabled={phase.disabled || isComplete}
                title={
                  isComplete 
                    ? `${phase.phase} - Fully Funded!` 
                    : phase.disabled 
                    ? `Coming Soon - ${phase.phase}` 
                    : `Donate for ${phase.phase}`
                }
              >
                {isComplete ? `✓ Fully Funded` : phase.disabled ? `Coming Soon` : `Donate for ${phase.phase}`}
              </button>
            </div>
          );
        })}
      </div>
      <br />
      <h1 className="dream-project-heading">Project Overview</h1>
      <section className="dream-status">
        <div className="dream-image-card">
          <img 
            src="/Images/dreamBuilding.png" 
            alt="Dream Project Building" 
            className="dream-building-image"
          />
        </div>
      </section>
    </div>
  );
};

export default DreamProject;